<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { pageHeader } from '../pageHeader'

const route = useRoute()
const { t } = useI18n()
const key = computed(() => route.meta.navKey)
const title = computed(() => pageHeader.title ?? (key.value ? t(`nav.${key.value}.label`) : ''))
// A page's own subtitle only applies with its own title; otherwise the nav's.
const subtitle = computed(() => pageHeader.title
  ? pageHeader.subtitle
  : key.value ? t(`nav.${key.value}.sub`) : null)
</script>

<template>
  <header class="flex flex-wrap items-start gap-x-4 gap-y-2 px-6 pb-3 pt-5 max-sm:px-4">
    <!-- Never squeezed by the actions: below 14rem they wrap under the title (found on 2026-10-01: on a phone the
         recycling page's buttons left its title 2 px wide). -->
    <div class="min-w-[min(100%,14rem)] flex-1">
      <h1 class="text-[20px] font-semibold tracking-[-.02em] text-foreground">{{ title }}</h1>
      <p v-if="subtitle" class="mt-1 max-w-[80ch] text-[13px] text-muted-foreground">{{ subtitle }}</p>
    </div>
    <div id="page-actions" class="flex min-w-0 max-w-full flex-wrap items-center gap-2" />
    <div id="page-filters" class="flex w-full flex-wrap items-center gap-2 empty:hidden" />
  </header>
</template>
